import * as React from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import type {} from '@mui/material/themeCssVarsAugmentation';
import DashboardSidebarContext from '../context/DashboardSidebarContext';
import { DRAWER_WIDTH } from '../constants';
import { getDrawerSxTransitionMixin } from '../mixins';

export interface DashboardSidebarHeaderItemProps {
  children?: React.ReactNode;
}

export default function DashboardSidebarHeaderItem({
  children,
}: DashboardSidebarHeaderItemProps) {
  const sidebarContext = React.useContext(DashboardSidebarContext);
  if (!sidebarContext) {
    throw new Error('Sidebar context was used without a provider.');
  }
  const {
    mini = false,
    fullyExpanded = true,
    hasDrawerTransitions,
  } = sidebarContext;

  return (
    <ListSubheader
      sx={(theme) => ({
        fontSize: 11,
        fontWeight: '700',
        height: mini ? 0 : 36,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        color: 'rgba(0, 0, 0, 0.5)',
        backgroundColor: 'transparent',
        ...theme.applyStyles('dark', {
          color: 'rgba(255, 255, 255, 0.6)',
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
        }),
        ...(hasDrawerTransitions
          ? getDrawerSxTransitionMixin(fullyExpanded, 'height')
          : {}),
        px: 2,
        py: 0,
        minWidth: DRAWER_WIDTH,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        zIndex: 2,
      })}
    >
      {children}
    </ListSubheader>
  );
}
